import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';

// TODO: update this file with Filters = { [filterGroupName: string]: { arrayFilters: Array<string>, values: { [filterName: string]: any } } }
export type Filters = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [filterGroupName: string]: { [filterName: string]: any };
};

type ArrayFilters = {
  [filterGroupName: string]: string[];
};

export type FiltersState = {
  readonly data: Filters;
  readonly queryString: string;
  readonly saveOrderViewModalIsOpen: boolean;
  readonly showNewTab: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly filterGroups: any[];
  readonly filterGroupsIsLoading: boolean;
  readonly deleteOrderViewModalIsOpen: boolean;
  readonly arrayFilters: ArrayFilters;
  readonly tempFilterGroup: Maybe<Filters>;
};

export const initialState: FiltersState = {
  data: {},
  queryString: '',
  saveOrderViewModalIsOpen: false,
  showNewTab: false,
  filterGroups: [],
  filterGroupsIsLoading: false,
  deleteOrderViewModalIsOpen: false,
  arrayFilters: {},
  tempFilterGroup: null,
};

function reducer(state = initialState, action: ActionTypes): FiltersState {
  switch (action.type) {
    case ActionKeys.FILTER_INIT:
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.filterGroupName]: action.payload.initialValues,
        },
        arrayFilters: {
          ...state.arrayFilters,
          [action.payload.filterGroupName]: action.payload.arrayFilters,
        },
      };
    case ActionKeys.FILTER_CHANGED:
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.filterGroupName]: {
            ...state.data[action.payload.filterGroupName],
            [action.payload.filterName]: action.payload.value,
          },
        },
      };
    case ActionKeys.FILTER_RESET:
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.filterGroupName]: {},
        },
      };
    case ActionKeys.FILTER_OPEN_SAVE_MODAL:
      return {
        ...state,
        saveOrderViewModalIsOpen: true,
      };
    case ActionKeys.FILTER_CLOSE_SAVE_MODAL:
      return {
        ...state,
        saveOrderViewModalIsOpen: false,
      };
    case ActionKeys.FILTER_OPEN_DELETE_MODAL:
      return {
        ...state,
        deleteOrderViewModalIsOpen: true,
      };
    case ActionKeys.FILTER_CLOSE_DELETE_MODAL:
      return {
        ...state,
        deleteOrderViewModalIsOpen: false,
      };
    case ActionKeys.FILTER_SET_QUERY_VALUE:
      return {
        ...state,
        queryString: action.payload.value,
      };
    case ActionKeys.FILTER_SAVE_FILTER_GROUP_SUCCESS:
      return {
        ...state,
        saveOrderViewModalIsOpen: false,
        showNewTab: false,
        filterGroups: [...state.filterGroups, action.payload.data],
      };
    case ActionKeys.FILTER_SAVE_FILTER_GROUP_ERROR:
      return {
        ...state,
        saveOrderViewModalIsOpen: false,
      };
    case ActionKeys.FILTER_GET_FILTER_GROUPS:
      return {
        ...state,
        filterGroupsIsLoading: true,
      };
    case ActionKeys.FILTER_GET_FILTER_GROUPS_SUCCESS:
      return {
        ...state,
        filterGroups: action.payload.data,
        filterGroupsIsLoading: false,
      };
    case ActionKeys.FILTER_GET_FILTER_GROUPS_ERROR:
      return {
        ...state,
        filterGroupsIsLoading: false,
      };
    case ActionKeys.FILTER_DELETE_FILTER_GROUP_SUCCESS:
      return {
        ...state,
        deleteOrderViewModalIsOpen: false,
      };
    case ActionKeys.FILTER_DELETE_FILTER_GROUP_ERROR:
      return {
        ...state,
        deleteOrderViewModalIsOpen: false,
      };
    case ActionKeys.FILTER_SHOW_NEW_TAB:
      return {
        ...state,
        showNewTab: true,
      };
    case ActionKeys.FILTER_HIDE_NEW_TAB:
      return {
        ...state,
        showNewTab: false,
      };
    case ActionKeys.FILTER_CHANGE_TAB_SUCCESS:
      return {
        ...state,
      };
    case ActionKeys.FILTER_SAVE_TEMP_GROUP:
      return {
        ...state,
        tempFilterGroup: action.payload.filters,
      };
    default:
      return state;
  }
}

export default reducer;
